"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _dialog = _interopRequireDefault(require("@ux/dialog"));
var _tooltip = _interopRequireDefault(require("@ux/tooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InfoIconWrapper = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "InfoIconWrapper",
  class: "pl-iobtplv"
});
const TooltipHeading = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "TooltipHeading",
  class: "pl-t1m62ed8"
});
const StyledDialog = /*#__PURE__*/(0, _react2.styled)(_dialog.default)({
  name: "StyledDialog",
  class: "pl-s1eyf3pc"
});
const StyledTooltip = /*#__PURE__*/(0, _react2.styled)(_tooltip.default)({
  name: "StyledTooltip",
  class: "pl-s4xfsht"
});
const InfoTooltip = ({
  title,
  message
}) => {
  const [show, setShow] = (0, _react.useState)(false);
  const anchorRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(InfoIconWrapper, {
    ref: anchorRef,
    onClick: () => setShow(!show)
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "information"
  })), /*#__PURE__*/_react.default.createElement(StyledTooltip, {
    className: "ux-tooltip",
    anchorRef: anchorRef,
    open: show,
    onClose: () => setShow(false)
  }, /*#__PURE__*/_react.default.createElement(StyledDialog, {
    title: /*#__PURE__*/_react.default.createElement(TooltipHeading, null, title),
    onClose: () => setShow(false)
  }, message)));
};
InfoTooltip.propTypes = {
  title: _propTypes.default.string,
  message: _propTypes.default.string
};
var _default = exports.default = InfoTooltip;